import { Box } from '@mui/material'
import { Seo } from '@/components/common'
import { WhyLeruSection } from '@/components/sections'

/**
 * Why Us Page Component
 * Explains why customers should choose Leru Systems
 */
export const WhyUsPage = () => {
  return (
    <Box>
      <Seo
        title="Why Leru Systems"
        description="Discover why plumbing companies choose Leru Systems for websites built specifically for small businesses to generate more leads and customers."
        path="/why-us"
      />
      <WhyLeruSection />
      {/* <TestimonialsSection /> */}
    </Box>
  )
}
